import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageSwitcher = () => {
  const [language, setLanguage] = useState('en');
  const navigate = useNavigate();
  const location = useLocation();

  // Lista de rutas que no deben tener el prefijo /es
  const excludedRoutes = [
    '/AdminUsersPanel',
    '/userTable',
    '/UserRegistration',
    '/UserManagementTable',
    '/ProductRegistration',
    '/pdfver',
    '/products/all',
    '/login',
    '/LoginAdmin'
  ];

  const handleToggleLanguage = () => {
    const currentPath = location.pathname;

    // Verifica si la ruta actual está en la lista de exclusiones
    const isExcludedRoute = excludedRoutes.some(route => currentPath === route);

    if (language === 'en') {
      setLanguage('es');
      if (!currentPath.startsWith('/es') && !isExcludedRoute) {
        navigate(`/es${currentPath === '/' ? '/home' : currentPath}`);
      }
    } else {
      setLanguage('en');
      navigate(currentPath.replace('/es', '') || '/');
    }
  };

  return (
    <div style={styles.switchContainer}>
      <label style={styles.label}>
        <input
          type="checkbox"
          onChange={handleToggleLanguage}
          checked={language === 'es'}
          style={styles.checkbox}
        />
        <span style={styles.switch}>
          {language === 'en' ? 'EN' : 'ES'}
        </span>
      </label>
    </div>
  );
};

// Estilos en línea ajustados
const styles = {
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1rem',
  },
  label: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    display: 'none',
  },
  switch: {
    display: 'inline-block',
    padding: '5px 10px',
    backgroundColor: '#697565',
    color: '#fff',
    borderRadius: '25px',
    fontWeight: 'bold',
    userSelect: 'none',
    fontSize: '0.9rem',

    transition: 'background-color 0.3s',
  },
};

export default LanguageSwitcher;
